// extracted by mini-css-extract-plugin
export default {"primary":"#5b0b93","primaryActive":"#cf0"};